export const NOTIFICATIONS_BY_USER = "NOTIFICATIONS_BY_USER";
export const GLOBAL_NOTIFICATIONS = "GLOBAL_NOTIFICATIONS";
export const FCM_SUBSCRIPTION = "FCM_SUBSCRIPTION";
